import axiosHttp from "services/axiosHttp";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchActionCenterStats = createAsyncThunk(
	"actionCenter/fetchStats",
	async ({ channel_id, date_filter }, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.get(`/sales/action-center/stats?channel_id=${channel_id}&date_filter=${date_filter}`);
			return response.data.data;
		} catch (error) {
			return rejectWithValue(error.response?.data?.message || "Failed to fetch stats");
		}
	}
);

export const fetchActionCenterPipeline = createAsyncThunk(
	"actionCenter/fetchPipeline",
	async ({ channel_id, date_filter }, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.get(`/sales/action-center/pipeline?channel_id=${channel_id}&date_filter=${date_filter}`);
			return response.data.data;
		} catch (error) {
			return rejectWithValue(error.response?.data?.message || "Failed to fetch pipeline");
		}
	}
);

export const fetchActionCenterPerformers = createAsyncThunk(
	"actionCenter/fetchPerformers",
	async ({ channel_id, date_filter }, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.get(`/sales/action-center/performers?channel_id=${channel_id}&date_filter=${date_filter}`);
			return response.data.data;
		} catch (error) {
			return rejectWithValue(error.response?.data?.message || "Failed to fetch performers");
		}
	}
);

const ActionCenterSlice = createSlice({
	name: "ActionCenterSlice",
	initialState: {
		stats: { isLoading: false, data: null, error: null },
		pipeline: { isLoading: false, data: null, error: null },
		performers: { isLoading: false, data: null, error: null },
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchActionCenterStats.pending, (state) => { state.stats.isLoading = true; state.stats.error = null; })
			.addCase(fetchActionCenterStats.fulfilled, (state, action) => { state.stats.isLoading = false; state.stats.data = action.payload; })
			.addCase(fetchActionCenterStats.rejected, (state, action) => { state.stats.isLoading = false; state.stats.error = action.payload; })

			.addCase(fetchActionCenterPipeline.pending, (state) => { state.pipeline.isLoading = true; state.pipeline.error = null; })
			.addCase(fetchActionCenterPipeline.fulfilled, (state, action) => { state.pipeline.isLoading = false; state.pipeline.data = action.payload; })
			.addCase(fetchActionCenterPipeline.rejected, (state, action) => { state.pipeline.isLoading = false; state.pipeline.error = action.payload; })

			.addCase(fetchActionCenterPerformers.pending, (state) => { state.performers.isLoading = true; state.performers.error = null; })
			.addCase(fetchActionCenterPerformers.fulfilled, (state, action) => { state.performers.isLoading = false; state.performers.data = action.payload; })
			.addCase(fetchActionCenterPerformers.rejected, (state, action) => { state.performers.isLoading = false; state.performers.error = action.payload; });
	},
});

export default ActionCenterSlice.reducer;
